import { render, staticRenderFns } from "./BenefitValuesChart.vue?vue&type=template&id=6c5f6acd&"
import script from "./BenefitValuesChart.vue?vue&type=script&lang=js&"
export * from "./BenefitValuesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports